import { ca } from '@cian/analytics';
import { IProduct } from '../../types/product';

/**
 * Обновляет состояние products в @cian/analytics
 * @param { IProduct } products - Массив products, который хранится внутри @cian/analytics
 */
export const setTrackingProducts = (products: IProduct[]) => {
  ca('products', products);
};
